import {
  base_colorAlert,
  blue100,
  cta_buttonPrimaryBackground,
  grey200,
  red100,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  transition_fast,
  transition_slow,
  transition_slower,
} from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
  font_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  transition: background-color ${transition_slower} ease-out;

  &.activeExpanded {
    background-color: ${grey200};
  }

  .sidenav-wrapper {
    width: 100%;
  }

  .sidenav-content {
    position: relative;
  }

  .sidenav-item {
    display: flex;
    height: ${spacing(9)};
    align-items: center;
    align-self: stretch;
    position: relative;
    gap: ${spacing(3)};
    border-radius: ${spacing(2)};
    transition-property: margin, padding, max-width, background-color;
    transition-duration:
      ${transition_slower}, ${transition_slower}, ${transition_slower},
      ${transition_slow};
    transition-timing-function: ease-out;

    &.sidenav-open {
      padding: 0 ${spacing(1)};
      margin: 0 ${spacing(4)};
      max-width: 100%;
    }
    &.sidenav-closed {
      padding: 0 ${spacing(1.5)};
      margin: 0 ${spacing(1)};
      max-width: 31px;
    }
    &:hover,
    &.active,
    &.expanded:hover {
      background-color: ${blue100};
    }
    &:hover.jpm,
    &.active.jpm {
      background-color: ${grey200};
    }

    &.expanded {
      background-color: transparent;
    }
  }

  .sidenav-icon {
    display: flex;
    position: relative;
  }

  .sidenav-notification-icon {
    position: absolute;
    bottom: ${spacing(1)};
    right: -${spacing(0.5)};
    transition: opacity ${transition_slower} ease-out;

    &.sidenav-open {
      opacity: 0;
    }
    &.sidenav-closed {
      opacity: 1;
    }
  }

  .sidenav-label-container {
    margin-left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .sidenav-label {
    &.button {
      ${font_sm};
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextSecondary};
    }
    &.navItem {
      ${font_md};
      font-family: ${font_family_weight_regular};

      &.active {
        color: ${cta_buttonPrimaryBackground};
      }
      &.inactive {
        color: ${text_colorTextPrimary};
      }
    }
  }

  .sidenav-notification-badge {
    position: absolute;
    right: ${spacing(1)};
    transition: opacity ${transition_slower} ease-out;

    &.sidenav-open {
      opacity: 1;
    }
    &.sidenav-closed {
      opacity: 0;
    }
  }

  .sidenav-notification-badge-inner {
    display: flex;
    padding: 0 ${spacing(1)};
    justify-content: center;
    align-items: center;
    gap: 1px;
    border-radius: 5px;
    background-color: ${red100};
    ${font_xs};
    color: ${base_colorAlert};
    font-family: ${font_family_weight_medium};
  }

  .sidenav-chevron {
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: ${spacing(1)};

    &.sidenav-open {
      opacity: 1;
    }
    &.sidenav-closed {
      opacity: 0;
    }

    & .icon {
      transition:
        opacity ${transition_slower} ease-out,
        transform ${transition_fast} ease-in-out;
      transform: rotate(0);
      &.expanded {
        transform: rotate(180deg);
      }
    }
  }

  .sidenav-expanded-container {
    display: flex;
    flex-direction: column;
    padding: ${spacing(1)} 0;
    gap: ${spacing(1)};
  }
`
